// extracted by mini-css-extract-plugin
module.exports = {"Letter":"Letter__3KYQ1"};